import PropTypes from "prop-types";
import React from "react";

import { Container, CssBaseline, useMediaQuery, useScrollTrigger } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

import { useLocation } from "react-router-dom";

import Banner from "../shared/Banner";
import Footer from "../shared/Footer";
import MainHeader from "../shared/MainHeader";
import ScrollTop from "../../components/_common/BackToTop";
import SkipList from "../../components/_common/SkipList";

const useStyles = makeStyles((theme) => ({
    mainContainer: {
        padding: theme.spacing(0, 2, 2, 2),
        maxWidth: 1488,
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(0, 0, 0, 0),
        },
    },
}));

function ElevationScroll(props) {
    const { children, window } = props;
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 20,
        target: window ? window() : undefined,
    });

    return React.cloneElement(children, {
        elevation: trigger ? 4 : 0,
    });
}

ElevationScroll.propTypes = {
    children: PropTypes.element.isRequired,
};

const HomeView = (props) => {
    const { noBanner = false } = props;
    const classes = useStyles();
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"));
    const location = useLocation();
    const showBanner = location.pathname !== "/deklaracja" && location.pathname !== "/polityka-prywatnosci";

    return (
        <React.Fragment>
            <div id="back-to-top-anchor" />
            <Container maxWidth={false}>
                <CssBaseline />
                <SkipList
                    path={props?.children?.props?.match?.path}
                    name={props?.children?.props?.match?.params?.name}
                />
                <>
                    <ElevationScroll {...props}>
                        <MainHeader isMobile={isMobile} />
                    </ElevationScroll>

                    {!!noBanner || (showBanner && <Banner isMobile={isMobile} />)}
                </>

                <Container maxWidth={false} className={classes.mainContainer}>
                    {props.children}
                </Container>
            </Container>

            <Footer isMobile={isMobile} />

            <ScrollTop />
        </React.Fragment>
    );
};

export default HomeView;
